<template>
    <AppLayout>
        <div class="container px-3 py-4 mx-auto md:px-6 lg:px-8">
            <!-- Page Title -->
            <div class="mb-6">
                <h1 class="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white">Profile</h1>
                <!-- Breadcrumb -->
                <nav
                    class="text-sm text-gray-500 mb-6 dark:text-gray-300"
                    aria-label="Breadcrumb"
                >
                    <GoBack />
                </nav>
            </div>
            <!-- breadcrumb end -->

            <div class="px-2 py-5 space-y-12 bg-white md:px-4">
                <div>
                    <div class="flex flex-col items-center gap-4 md:flex-row">
                        <!-- user image -->
                        <div class="flex justify-center cursor-pointer">
                            <img
                                class="object-cover rounded w-60"
                                :src="kyc.logo"
                                :alt="kyc.person_name"
                            />
                        </div>

                        <div class="flex flex-col w-full gap-4">
                            <!-- person name -->
                            <div class="flex-grow">
                                <div class="block text-sm font-medium text-gray-700">Person Name*</div>
                                <div class="flex mt-1 rounded-md shadow-sm">
                                    <div class="w-full px-3 py-2 border rounded shadow-sm">
                                        {{ kyc.person_name | capitalize }}
                                    </div>
                                </div>
                            </div>

                            <!-- Email -->
                            <div>
                                <div class="block text-sm font-medium text-gray-700">Email</div>
                                <div class="flex mt-1 rounded-md shadow-sm">
                                    <div class="w-full px-3 py-2 border rounded shadow-sm">
                                        {{ kyc.email }}
                                    </div>
                                </div>
                            </div>

                            <!-- Phone -->
                            <div>
                                <div class="block text-sm font-medium text-gray-700">Phone</div>
                                <div class="flex mt-1 rounded-md shadow-sm">
                                    <div class="w-full px-3 py-2 border rounded shadow-sm">
                                        {{ kyc.phone }}
                                    </div>
                                </div>
                            </div>

                            <!-- dob and gender -->
                            <div class="flex flex-col gap-4 md:flex-row">
                                <!-- dob -->
                                <div class="flex-grow">
                                    <div class="block text-sm font-medium text-gray-700">DOB</div>
                                    <div class="flex mt-1 rounded-md shadow-sm">
                                        <div class="w-full px-3 py-2 border rounded shadow-sm">
                                            {{ kyc.dob | LL }}
                                        </div>
                                    </div>
                                </div>

                                <!-- gender -->
                                <div class="flex-grow">
                                    <div class="block text-sm font-medium text-gray-700">Gender</div>
                                    <div class="flex mt-1 rounded-md shadow-sm">
                                        <div class="w-full px-3 py-2 border rounded shadow-sm">
                                            {{ kyc.gender | capitalize }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
                        <!-- Company Name -->
                        <div>
                            <div class="block text-sm font-medium text-gray-700">Company Name</div>
                            <div class="flex mt-1 rounded-md shadow-sm">
                                <div class="w-full px-3 py-2 border rounded shadow-sm">
                                    {{ kyc.company_name | capitalize }}
                                </div>
                            </div>
                        </div>

                        <!-- Company Registration Number -->
                        <div>
                            <div class="block text-sm font-medium text-gray-700">Company Registration Number</div>
                            <div class="flex mt-1 rounded-md shadow-sm">
                                <div class="w-full px-3 py-2 border rounded shadow-sm">
                                    {{ kyc.company_registration_number | capitalize }}
                                </div>
                            </div>
                        </div>

                        <!-- Business Address -->
                        <div>
                            <div class="block text-sm font-medium text-gray-700">Business Address</div>
                            <div class="flex mt-1 rounded-md shadow-sm">
                                <div class="w-full px-3 py-2 border rounded shadow-sm">
                                    {{ kyc.business_address | capitalize }}
                                </div>
                            </div>
                        </div>

                        <!-- Bankers Name -->
                        <div>
                            <div class="block text-sm font-medium text-gray-700">Bankers Name</div>
                            <div class="flex mt-1 rounded-md shadow-sm">
                                <div class="w-full px-3 py-2 border rounded shadow-sm">
                                    {{ kyc.bankers_name | capitalize }}
                                </div>
                            </div>
                        </div>

                        <!-- Bankers address -->
                        <div>
                            <div class="block text-sm font-medium text-gray-700">Bankers Address</div>
                            <div class="flex mt-1 rounded-md shadow-sm">
                                <div class="w-full px-3 py-2 border rounded shadow-sm">
                                    {{ kyc.bankers_address | capitalize }}
                                </div>
                            </div>
                        </div>

                        <!-- Business References Name -->
                        <div>
                            <div class="block text-sm font-medium text-gray-700">Business References Name</div>
                            <div class="flex mt-1 rounded-md shadow-sm">
                                <div class="w-full px-3 py-2 border rounded shadow-sm">
                                    {{ kyc.business_references_name | capitalize }}
                                </div>
                            </div>
                        </div>

                        <!-- Business References Address -->
                        <div>
                            <div class="block text-sm font-medium text-gray-700">Business References Address</div>
                            <div class="flex mt-1 rounded-md shadow-sm">
                                <div class="w-full px-3 py-2 border rounded shadow-sm">
                                    {{ kyc.business_references_address | capitalize }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <div class="my-8">
                        <div class="text-xl font-bold text-center md:text-left">Documents</div>

                        <div class="grid grid-cols-3 gap-4 my-6">
                            <div class="relative group">
                                <div class="absolute items-center justify-center hidden w-full h-full group-hover:flex">
                                    <div class="w-full h-full bg-black rounded opacity-50" />
                                    <div class="absolute flex">
                                        <div @click="downloadImage(kyc.id_document)">
                                            <DownloadIcon
                                                class="h-6 text-white duration-100 ease-in transform cursor-pointer hover:text-green-500 hover:scale-150"
                                            />
                                        </div>
                                        <div
                                            class="ml-4"
                                            @click="openImageInNewTab(kyc.id_document)"
                                        >
                                            <ViewIcon
                                                class="h-6 text-white duration-100 ease-in transform cursor-pointer hover:text-green-500 hover:scale-150"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <img
                                    class="object-cover object-center w-full h-full rounded"
                                    :src="kyc.id_document"
                                />
                                <div class="mt-2">Identification Document</div>
                            </div>

                            <div class="relative group">
                                <div class="absolute items-center justify-center hidden w-full h-full group-hover:flex">
                                    <div class="w-full h-full bg-black rounded opacity-50" />
                                    <div class="absolute flex">
                                        <div @click="downloadImage(kyc.registration_certificate)">
                                            <DownloadIcon
                                                class="h-6 text-white duration-100 ease-in transform cursor-pointer hover:text-green-500 hover:scale-150"
                                            />
                                        </div>
                                        <div
                                            class="ml-4"
                                            @click="openImageInNewTab(kyc.registration_certificate)"
                                        >
                                            <ViewIcon
                                                class="h-6 text-white duration-100 ease-in transform cursor-pointer hover:text-green-500 hover:scale-150"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <img
                                    class="object-cover object-center w-full h-full rounded"
                                    :src="kyc.registration_certificate"
                                />
                                <div class="mt-2">Registration Document</div>
                            </div>

                            <div
                                v-if="kyc.vat_registration_certificate"
                                class="relative group"
                            >
                                <div class="absolute items-center justify-center hidden w-full h-full group-hover:flex">
                                    <div class="w-full h-full bg-black rounded opacity-50" />
                                    <div class="absolute flex">
                                        <div @click="downloadImage(kyc.vat_registration_certificate)">
                                            <DownloadIcon
                                                class="h-6 text-white duration-100 ease-in transform cursor-pointer hover:text-green-500 hover:scale-150"
                                            />
                                        </div>
                                        <div
                                            class="ml-4"
                                            @click="openImageInNewTab(kyc.vat_registration_certificate)"
                                        >
                                            <ViewIcon
                                                class="h-6 text-white duration-100 ease-in transform cursor-pointer hover:text-green-500 hover:scale-150"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <img
                                    class="object-cover object-center w-full h-full rounded"
                                    :src="kyc.vat_registration_certificate"
                                />
                                <div class="mt-2">Vat Registration Document</div>
                            </div>
                        </div>
                    </div>

                    <div
                        v-if="kyc.images.length"
                        class="mt-16"
                    >
                        <div class="text-xl font-bold text-center md:text-left">Other Documents</div>

                        <!-- Document images list -->
                        <div class="flex w-full gap-4 mt-6">
                            <div
                                v-for="image in kyc.images"
                                :key="'kyc-document-image-' + image.id"
                                class="relative flex w-1/3 group"
                            >
                                <div class="absolute items-center justify-center hidden w-full h-full group-hover:flex">
                                    <div class="w-full h-full bg-black rounded opacity-50" />
                                    <div class="absolute flex">
                                        <div @click="downloadImage(image.image_path)">
                                            <DownloadIcon
                                                class="h-6 text-white duration-100 ease-in transform cursor-pointer hover:text-green-500 hover:scale-150"
                                            />
                                        </div>
                                        <div
                                            class="ml-4"
                                            @click="openImageInNewTab(image.image_path)"
                                        >
                                            <ViewIcon
                                                class="h-6 text-white duration-100 ease-in transform cursor-pointer hover:text-green-500 hover:scale-150"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <img
                                    :src="image.image_path"
                                    class="object-cover object-center w-full h-full rounded"
                                />
                            </div>
                        </div>
                    </div>

                    <div
                        v-else
                        class="mt-16"
                    >
                        No other document is submitted
                    </div>

                    <div
                        v-if="kyc.notes && currentKycRejected"
                        class="mt-8"
                    >
                        Notes: {{ kyc.notes }}
                    </div>
                </div>
            </div>

            <div
                v-if="isAdmin && !currentKycVerified && !currentKycRejected"
                class="flex justify-end gap-4 px-4 py-3"
            >
                <t-button
                    variant="success"
                    @click="acceptRequest"
                >
                    Accept
                </t-button>

                <t-button
                    variant="error"
                    class="px-4 py-2"
                    @click="showRejectModal"
                >
                    Reject
                </t-button>
            </div>

            <div
                v-else
                class="px-4 py-3 space-x-4 text-right"
            >
                <div>
                    <div v-if="!currentKycRejected">
                        <t-button
                            variant="secondary"
                            :class="[currentKycVerified ? 'text-green-500' : 'text-yellow-500']"
                        >
                            {{ currentKycVerified ? 'Verified' : 'Pending' }}
                        </t-button>
                    </div>

                    <div
                        v-else
                        class="flex justify-end gap-4 px-4 py-3"
                    >
                        <t-button
                            variant="secondary"
                            :class="'text-red-500 focus:outline-none focus:ring-0'"
                        >
                            Rejected
                        </t-button>

                        <t-button
                            v-if="$page.props.user.id === kyc.user_id"
                            variant="success"
                            @click="reSubmit"
                        >
                            Resubmit
                        </t-button>
                    </div>
                </div>
            </div>

            <t-modal
                v-model="kycRejectModal"
                header="Reason For Rejection"
            >
                <t-textarea v-model="rejectionNotes" />
                <template #footer>
                    <div class="flex justify-between">
                        <t-button
                            type="button"
                            @click="hideRejectModal"
                        >
                            Cancel
                        </t-button>
                        <t-button
                            type="button"
                            @click="rejectRequest"
                        >
                            Confirm Rejection
                        </t-button>
                    </div>
                </template>
            </t-modal>
        </div>
    </AppLayout>
</template>

<script>
    import AppLayout from '../../Layouts/AppLayout.vue';
    import GoBack from '../../Components/GoBack.vue';
    import DownloadIcon from '../../Components/Icons/DownloadIcon.vue';
    import ViewIcon from '../../Components/Icons/ViewIcon.vue';

    export default {
        name: 'KycShow',

        components: {
            AppLayout,
            GoBack,
            DownloadIcon,
            ViewIcon,
        },

        props: {
            kyc: {
                type: Object,
                required: true,
            },
        },

        data() {
            return {
                kycRejectModal: false,
                rejectionNotes: null,
            };
        },

        computed: {
            currentKycVerified() {
                if (this.kyc.accepted_at) {
                    return true;
                }
                return false;
            },

            currentKycRejected() {
                if (this.kyc.deleted_at) {
                    return true;
                }
                return false;
            },
        },

        methods: {
            acceptRequest() {
                const payload = { _method: 'PUT', accepted: true };
                this.$inertia.post(this.kyc.path, payload, {
                    onFinish: () => {
                        this.goto('kyc.index');
                    },
                });
            },

            showRejectModal() {
                this.rejectionNotes = null;
                this.kycRejectModal = true;
            },

            hideRejectModal() {
                this.rejectionNotes = null;
                this.kycRejectModal = false;
            },

            rejectRequest() {
                const payload = { notes: this.rejectionNotes };
                this.$inertia.post(route('kyc.destroy', this.kyc.id), payload, {
                    onFinish: () => {
                        this.hideRejectModal();
                        this.goto('kyc.index');
                    },
                });
            },

            reSubmit() {
                this.$inertia.get(route('kyc.create'));
            },
        },
    };
</script>
